var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fa fa-eye",attrs:{"title":"Number of Watchers"}})}
var staticRenderFns = []

export { render, staticRenderFns }